import { useTranslation } from 'react-i18next';
import { Accordion, classes } from 'bonfire-kindling';

const SavedSearchSettingsUpsertAccordion = ({ id, expanded, onExpand, summary, children }) => {
  const { t } = useTranslation();

  return (
    <Accordion
      expanded={expanded}
      sx={{
        '&:first-of-type': {
          borderTop: 'none',
        },
        backgroundColor: theme => theme.palette.background.default,
      }}
    >
      <Accordion.Summary
        expandLabel={t('common.expand')}
        contractLabel={t('common.collapse')}
        summary={summary}
        onExpand={expanded => onExpand(expanded, id)}
        sx={{
          [`&.${classes.components.MuiAccordionSummary.root}`]: {
            border: theme => `2px solid ${theme.palette.background.default}`,
          },
        }}
      />
      <Accordion.Details>{children}</Accordion.Details>
    </Accordion>
  );
};

export default SavedSearchSettingsUpsertAccordion;
